import { createFileRoute, redirect } from "@tanstack/react-router";
import CertificationsPage from "@/pages/CertificationsPage";

export const Route = createFileRoute(
  "/$leaid/_error-wrapper/certification-cycles/"
)({
  component: CertificationsPage,
  beforeLoad: ({ context, params }) => {
    if (!context.hasRole("ReportsMonthly", "ReportsFall", "ReportsEOY")) {
      throw redirect({ to: "/$leaid", params: { leaid: params.leaid } });
    }
  },
});
